export default {
	API: process.env.REACT_APP_API || 'REPLACE_ME_API'
};
